import type { GeneralID, Member } from '@types';

export const thumbPrefix = ({
  memberData,
  sceneId,
}: { memberData: Partial<Member>; sceneId: GeneralID }): string => {
  const { property } = memberData;
  if (!property) throw new Error('memberData does not have property');
  return `/resource/prod/${property?.modHashId}/${property?.uid}/${sceneId}/imgs`;
};
